export const firebaseConfigDev = {
  apiKey: "AIzaSyB5jIFqgG1_GMmSfFu4_5WSK1CeinvP3JE",
  authDomain: "bula-instant-bets-dev-436918.firebaseapp.com",
  projectId: "bula-instant-bets-dev-436918",
  storageBucket: "bula-instant-bets-dev-436918.firebasestorage.app",
  messagingSenderId: "168730484159",
  appId: "1:168730484159:web:0378a525c7d16f9530550a"
};
export const firebaseConfigStaging = {
  apiKey: "AIzaSyDMztiIXTBREVrQ_2_RMJmjEFYk1B0c4Lg",
  authDomain: "bula-instants-bets-test.firebaseapp.com",
  projectId: "bula-instants-bets-test",
  storageBucket: "bula-instants-bets-test.firebasestorage.app",
  messagingSenderId: "369934987364",
  appId: "1:369934987364:web:ae832f11c1a85a4faaef71",
  measurementId: "G-RKGP8RJ410"
};
export const firebaseConfigProd = {
  apiKey: "AIzaSyB5x6T1xEo2zq0Y9x0zv_YQfkL4XC--rkk",
  authDomain: "bula-instant-bets.firebaseapp.com",
  projectId: "bula-instant-bets",
  storageBucket: "bula-instant-bets.firebasestorage.app",
  messagingSenderId: "253089719064",
  appId: "1:253089719064:web:8959a20eb3d105795f346d",
  measurementId: "G-TJCZWNNYN5"
};